import styled from 'styled-components'
import { clamp } from '../../styles/utils/conversion.style'
import { breakpoints } from '../../styles/vars/breakpoints.style'
import {
  AnimateSlideInContent,
  AnimateSlideInInner,
} from '../animation/AnimateSlideIn/index.style'
import { mq } from '../../styles/vars/media-queries.style'

import { ImageLabel } from '../ImageLabel/index.style'

export const ImageContentSplitMain = styled.div`
  background-color: ${props => props.bg};
  overflow: hidden;

  .react-parallax {
    border-top-left-radius: 0.6rem;
    border-top-right-radius: 0.6rem;
  }
`

export const ImageContentSplitImage = styled.div`
  max-height: 76vmin;
  overflow: hidden;
  border-top-left-radius: 0.6rem;
  border-top-right-radius: 0.6rem;
  transform: translateZ(0);
  position: relative;

  ${ImageLabel} {
    display: none;

    ${mq.tabletP} {
      display: flex;
    }
  }

  ${mq.tabletL} {
    max-height: none;
  }

  ${AnimateSlideInContent},
  ${AnimateSlideInInner} {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;

    ${mq.tabletL} {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
`

export const ImageContentSplitSecondaryImageWrap = styled.div`
  bottom: 4.8rem;
  display: none;
  position: ${props => (props.flip ? `` : `absolute`)};
  ${props =>
    !props.flip &&
    clamp('right', 22, 49, breakpoints.mobile, breakpoints.contained)}
  width: ${props => (props.flip ? `50%` : `14.5%`)};

  @media (min-width: 1500px) {
    display: block;
  }
`

export const ImageContentSplitSecondaryImage = styled.div`
  border-radius: 0.6rem;
  overflow: hidden;
`
